import { render, staticRenderFns } from "./Mobile-App-Development.vue?vue&type=template&id=6423c84e&scoped=true&"
import script from "./Mobile-App-Development.vue?vue&type=script&lang=js&"
export * from "./Mobile-App-Development.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6423c84e",
  null
  
)

export default component.exports